import { getCookie } from '../utils/cookies';

export default {
  language: getCookie('_culture') || 'pl',

  rootReducer: {
    message: 'hi iam from store',
  },
};
